import { render, staticRenderFns } from "./VBtn.vue?vue&type=template&id=5096663a&lang=pug&"
import script from "./VBtn.vue?vue&type=script&lang=js&"
export * from "./VBtn.vue?vue&type=script&lang=js&"
import style0 from "./VBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports